import { Injectable } from "@angular/core";
import { ToastService } from "../../../services/toast.service";
import { HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { IAppState } from "../../../../app/store/app/app.state";
import { HasSubscriptions } from "../../higher-order/has-subscriptions";
import { FileSelectLabels } from "./file.utils";
import { BehaviorSubject, Observable } from "rxjs";
import { ReportingService } from "@gms/reporting-api";
import { LoaderService } from "app/modules/administration/pages/posting/view-posting/posting.service";
import { HttpCodes } from "shared/consts/http-codes.const";
import { DownloadPostingDocumentAction } from "app/store/posting/posting.actions";
import { DownloadNoticeDocumentAction } from "app/store/notices/notice.actions";
import { BISACONSTANTS } from "app/modules/bisa/bisa-constants";

@Injectable({
  providedIn: 'root'
})

export class FileSelectService extends HasSubscriptions {

  private loaderSubject = new BehaviorSubject<boolean>(false);
  loading1$: Observable<boolean>;

  constructor(private _toastService: ToastService,
    private _store: Store<IAppState>,
    private _reportService: ReportingService,
    private _loader: LoaderService) {
    super();

    this.loading1$ = this.loaderSubject.asObservable();
  }

  processDownloadNoticeDocument(noticeID: number) {
    this._reportService.getNoticeDocumentById(noticeID, "response").subscribe(resp => {
      this.downloadDocument(resp);
      this._toastService.success(FileSelectLabels.downloadDocSuccess);
      this._loader.toggleLoader();
    }, (error: HttpErrorResponse) => {
      if (error.status === HttpCodes.NOT_FOUND) {
        this._toastService.showError(FileSelectLabels.fileNotFound);
        this._loader.toggleLoader();
      }
    });
  }

  processDownloadDocument(infopostTrackID: number) {
    this._reportService.getPostingsDocumentById(infopostTrackID, "response").subscribe(resp => {
      this.downloadDocument(resp);
      this._toastService.success(FileSelectLabels.downloadDocSuccess);
      this._loader.toggleLoader();
    }, (error: HttpErrorResponse) => {
      if (error.status === HttpCodes.NOT_FOUND) {
        this._toastService.showError(FileSelectLabels.fileNotFound);
        this._loader.toggleLoader();
      }
    });
  }

  downloadDocument(response: HttpResponse<Blob>) {
    const contentDisposition = response.headers.get('Content-Disposition');
    let filename: string = "Default." + response.body.type.split('/')[1];
    if (contentDisposition) {
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    // save the file
    const blob = new Blob([response.body], { type: response.body.type || 'application/octet-stream' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;

    document.body.appendChild(link);
    link.click();

    // Clean-up and revoke object urls
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  }

  dispatchDownloadDocument(id: number, type: 'POSTING' | 'NOTICE') {
    if (type === 'POSTING')
      this._store.dispatch(new DownloadPostingDocumentAction(id));
    else
      this._store.dispatch(new DownloadNoticeDocumentAction(id));
  }

  blmDownloadDocument() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = `assets/docs/${BISACONSTANTS.homeBLMFileName}`;
    link.download = BISACONSTANTS.homeBLMFileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }


}
